import { CommonModule, NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink, RouterModule } from '@angular/router';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import { ToastrService } from 'ngx-toastr';
import { Subject, catchError, finalize, of, takeUntil } from 'rxjs';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { ResetPasswordRequest } from '../../models/general/ResetPasswordRequest';
import { AuthenticationService } from '../../services/authentication.service';
import { LoadingService } from '../../services/loading.service';
import { confirmPasswordValidator, passwordValidator, whitespaceValidator } from '../../validators/ValidationService';

@Component({
    selector: 'app-reset-password',
    imports: [RouterLink, NgClass, FileUploadModule, RouterModule, ReactiveFormsModule, CommonModule],
    templateUrl: './reset-password.component.html',
    styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {

    // Password Show/Hide
    isPassword1Visible: boolean = false;
    isPassword2Visible: boolean = false;
    isPassword3Visible: boolean = false;
    togglePassword1Visibility(): void {
        this.isPassword1Visible = !this.isPassword1Visible;
    }
    togglePassword2Visibility(): void {
        this.isPassword2Visible = !this.isPassword2Visible;
    }
    togglePassword3Visibility(): void {
        this.isPassword3Visible = !this.isPassword3Visible;
    }


    isToggled = false;
    frmResetPasswordForm!: FormGroup;
    isSubmitted = false;
    destroy$: Subject<boolean> = new Subject<boolean>();
    userResetPass = new ResetPasswordRequest();

    constructor(public router: Router,
        private formBuilder: FormBuilder,
        public themeService: CustomizerSettingsService,
        public authService: AuthenticationService,
        private toasterService: ToastrService,
        private loadingService: LoadingService,
        private route: ActivatedRoute,
    ) {
        this.initialize();
    }

    public ngOnInit(): void {
        if (this.authService.isUserAuthenticated()) {
        }
    }

    public ngAfterViewInit(): void {

        this.frmResetPasswordForm.controls['newPasswordControl'].valueChanges.subscribe(value => {
            this.userResetPass.password = value;
        });
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    private initialize(): void {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
        this.isSubmitted = false;
        this.userResetPass = new ResetPasswordRequest();

        this.createForm();
    }

    private createForm(): void {
        this.frmResetPasswordForm = this.formBuilder.group({
            newPasswordControl: new FormControl('', [Validators.required, passwordValidator(), whitespaceValidator]),
            confirmPasswordControl: new FormControl('', [Validators.required, passwordValidator(), whitespaceValidator]),
        },
            {
                validator: confirmPasswordValidator('newPasswordControl', 'confirmPasswordControl')
            })
    }

    get f() { return this.frmResetPasswordForm.controls; }

    public toggleClass(): void {
        this.router.navigate(["/dashboard"]);
    }


    public formIsValid(): boolean {
        const isValid = this.frmResetPasswordForm.controls['newPasswordControl'].valid &&
            this.frmResetPasswordForm.controls['confirmPasswordControl'].valid
        return isValid;
    }

    public onSubmit(): void {
        if (this.frmResetPasswordForm.valid) {
            this.loadingService.showLoading();
            this.route.queryParams.subscribe((params) => {
                if (params['token']) {
                    this.userResetPass.resetCode = params['token'];
                }
                if (params['e']) {
                    this.userResetPass.email = params['e'];
                }
            });

            this.authService.resetPassword(this.userResetPass)
                .pipe(
                    catchError((err: any) => {
                        if (err && err.error) {
                            this.isSubmitted = false;
                            if (err.error.isCustom) {
                                this.toasterService.warning(err.error.message);
                            } else {
                                this.toasterService.error('Something went wrong!');
                            }
                        } else {
                            this.isSubmitted = false;
                            this.toasterService.error('Something went wrong!');
                        }
                        this.loadingService.hideLoading();

                        return of(null);
                    }),
                    finalize(() => {
                        this.loadingService.hideLoading();
                    }),
                    takeUntil(this.destroy$))
                .subscribe(response => {
                    if (response) {
                        this.isSubmitted = false;
                        this.toasterService.success("Save successfully");
                        this.authService.logout();
                    }
                    this.loadingService.hideLoading();
                });
        }
    }

}